import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const TableSortingsStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-sorting",
})`
  .MuiFormControl-root {
    width: 100%;
  }
`;

export const TableSortingsRow = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-sorting-row",
})``;
